/* AVELLE · carrito lateral de Horizon modelado 1:1 sobre SILVORA (sv-cart.js), todo en español de España.
   Protección de envío opcional (sin marcar por defecto: en la UE no se permiten casillas de pago pre-marcadas),
   sellos de confianza y apertura del carrito lateral al añadir desde la página de producto. */
(function () {
  var PROT = 45871122808898, HANDLE = 'shipping-protection';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var price = '';
  var css = '.sv-prot{align-self:stretch;width:100%;box-sizing:border-box;display:flex;align-items:center;gap:12px;padding:12px 14px;margin:0 0 12px;border:1.5px solid #ecdcd2;border-radius:12px;background:#fbf3ee;cursor:pointer;font-size:13px;line-height:1.35;color:#121212}' +
    '.sv-prot input{width:20px;height:20px;accent-color:#c47245;flex:0 0 auto;margin:0;cursor:pointer}' +
    '.sv-prot input[type=checkbox]{-webkit-appearance:none!important;appearance:none!important;box-sizing:border-box;width:20px!important;height:20px!important;border:1.5px solid #c47245!important;border-radius:5px!important;background:#fff!important;display:grid;place-content:center;padding:0}' +
    '.sv-prot input[type=checkbox]:checked{background:#c47245 url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3E%3Cpath d=%27M3.5 8.5l3 3 6-7%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272.2%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27/%3E%3C/svg%3E") center/15px 15px no-repeat!important;border-color:#c47245!important}' +
    '.sv-prot input[type=checkbox]::before,.sv-prot input[type=checkbox]::after{content:none!important;display:none!important}' +
    '.sv-prot__ico{font-size:22px;flex:0 0 auto}.sv-prot__t{flex:1}.sv-prot__t b{display:block;font-size:14px}.sv-prot__t small{color:#5a5a5a}' +
    '.sv-prot__p{font-weight:700;white-space:nowrap}.sv-prot.busy{opacity:.6;pointer-events:none}' +
    '.sv-ctrust{align-self:stretch;display:flex;justify-content:space-around;flex-wrap:wrap;gap:6px;margin-top:10px;font-size:12px;font-weight:600;color:#121212;text-align:center}';
  var st = document.createElement('style'); st.textContent = css; document.head.appendChild(st);

  function isCartPage() { return location.pathname.replace(root, '/') === '/cart'; }
  function cart() { return fetch(root + 'cart.js').then(function (r) { return r.json(); }); }
  function qtyOf(c) { var q = 0; c.items.forEach(function (i) { if (i.variant_id === PROT) q += i.quantity; }); return q; }

  function refresh(open) {
    return fetch(root + '?section_id=cart-drawer-section').then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var cur = document.querySelector('#cart-drawer .cart-drawer__inner'), nu = doc.querySelector('.cart-drawer__inner');
      var sec = document.querySelector('#shopify-section-cart-drawer-section');
      if (sec) { // los estilos del carrito con productos no vienen si la página cargó con el carrito vacío
        sec.querySelectorAll('style.sv-cd-style').forEach(function (s) { s.remove(); });
        doc.querySelectorAll('style').forEach(function (s) { var c = document.createElement('style'); c.className = 'sv-cd-style'; c.textContent = s.textContent; sec.appendChild(c); });
      }
      if (cur && nu) {
        for (var k = 0; k < nu.attributes.length; k++) cur.setAttribute(nu.attributes[k].name, nu.attributes[k].value);
        cur.innerHTML = nu.innerHTML;
      }
      return cart();
    }).then(function (c) {
      document.querySelectorAll('.cart-bubble__text, #cart-bubble-text').forEach(function (b) { b.textContent = c.item_count; });
      document.querySelectorAll('.cart-bubble').forEach(function (b) { b.classList.toggle('visually-hidden', !c.item_count); });
      inject(c);
      if (open) { var d = document.querySelector('#cart-drawer'); if (d && d.open) d.open(); else if (!isCartPage() && open === true) location.href = root + 'cart'; }
      if (isCartPage() && open === 'page') location.reload();
    });
  }

  function toggle(on, box) {
    box.classList.add('busy');
    var req = on
      ? fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: [{ id: PROT, quantity: 1 }] }) })
      : fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(PROT), quantity: 0 }) });
    req.then(function () { return refresh(isCartPage() ? 'page' : false); });
  }

  function widget(on) {
    var l = document.createElement('label'); l.className = 'sv-prot';
    l.innerHTML = '<input type="checkbox"' + (on ? ' checked' : '') + '><span class="sv-prot__ico">🛡️</span>' +
      '<span class="sv-prot__t"><b>Protección de envío</b><small>Cubre pérdida, robo y daños durante el transporte</small></span>' +
      '<span class="sv-prot__p">' + price + '</span>';
    l.querySelector('input').addEventListener('change', function (e) { toggle(e.target.checked, l); });
    return l;
  }

  function inject(c) {
    var only = c.items.length && c.items.every(function (i) { return i.variant_id === PROT; });
    if (only) { // si solo queda la protección, se quita sola
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: String(PROT), quantity: 0 }) })
        .then(function () { refresh(isCartPage() ? 'page' : false); });
      return;
    }
    var on = qtyOf(c) > 0;
    document.querySelectorAll('.cart-drawer__summary, .cart__summary-inner, .cart-summary__inner').forEach(function (s) {
      var old = s.querySelector(':scope > .sv-prot'); if (old) old.remove();
      if (c.item_count) s.insertBefore(widget(on), s.firstChild);
      if (c.item_count && !s.querySelector('.sv-ctrust')) {
        var tr = document.createElement('div'); tr.className = 'sv-ctrust';
        tr.innerHTML = '<span>↩️ Garantía de 90 días</span><span>📦 Envío con seguimiento</span><span>🔒 Pago seguro</span>';
        s.appendChild(tr);
      }
    });
  }

  function sync() { cart().then(inject); }

  // Botón «Añadir al carrito» de la página de producto: en vez de ir a /cart, abre el carrito lateral (como SILVORA).
  window.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.matches || !f.matches('form[data-av-form]') || !document.querySelector('#cart-drawer')) return;
    e.preventDefault(); e.stopPropagation();
    var inp = f.querySelector('input[name=id]:checked') || f.querySelector('[name=id]');
    if (!inp) return;
    var btn = f.querySelector('[data-atc]'); if (btn) btn.disabled = true;
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +inp.value, quantity: 1 }] }) })
      .then(function () { return refresh(true); })
      .catch(function () { location.href = root + 'cart'; })
      .finally(function () { if (btn) btn.disabled = false; });
  }, true);

  fetch(root + 'products/' + HANDLE + '.js').then(function (r) { return r.json(); }).then(function (p) {
    var cents = p.variants[0].price, cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
    try { price = '+' + new Intl.NumberFormat('es-ES', { style: 'currency', currency: cur }).format(cents / 100); } catch (e) { price = ''; }
  }).finally(sync);

  // Horizon re-renderiza el carrito al cambiar cantidades: volver a poner la casilla
  var t;
  new MutationObserver(function () {
    clearTimeout(t);
    t = setTimeout(function () {
      var need = false;
      document.querySelectorAll('.cart-drawer__summary, .cart__summary-inner, .cart-summary__inner').forEach(function (s) { if (!s.querySelector(':scope > .sv-prot')) need = true; });
      if (need) sync();
    }, 250);
  }).observe(document.body, { childList: true, subtree: true });

  window.svCart = { refresh: refresh };
})();
